import React from 'react';
import { Dialog, Paper, Chip, Typography, Card, CardMedia, Button } from '@material-ui/core';
import { Flag } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { setNotifications } from '../redux';

export default () => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const notifications = useSelector(state => state.tasks.notifications);
  const fontSize = width <= 500 ? '4vw' : '20px';

  return (
    <Dialog open={notifications.open} fullWidth>
      <Button
        onClick={() => dispatch(setNotifications({ ...notifications, open: false }))}
        variant="contained"
        style={{ width: '100%' }}
      >
        <Typography gutterBottom component="span" style={{ fontSize }}>
          Затвори
        </Typography>
      </Button>
      {notifications.list.length > 0 ? (
        notifications.list.map(x => (
          <Paper key={x.key} style={{ padding: '4px' }}>
            <Typography style={{ fontSize }}>
              <Chip style={{ marginRight: '2px' }} label={x.key + 1} />
              {x.changeTypeText}
            </Typography>
            <Card>
              <CardMedia>
                <div style={{ backgroundColor: x.backgroundColor, padding: '3px' }}>
                  <Chip style={{ margin: '1px', marginRight: '2px' }} label={x.time} />
                </div>
                <Typography gutterBottom component="h2" style={{ fontSize }}>
                  <Flag style={{ fontSize, marginRight: '2px' }} />
                  {x.taskType}
                </Typography>
                {x.changes.map(y => (
                  <Typography gutterBottom component="h2" style={{ fontSize }}>
                    {y}
                  </Typography>
                ))}
              </CardMedia>
            </Card>
          </Paper>
        ))
      ) : (
        <Paper style={{ padding: '4px' }}>
          <Typography gutterBottom component="h2" style={{ fontSize }}>
            Няма промени по задачите
          </Typography>
        </Paper>
      )}
    </Dialog>
  );
};
